export default "__VITE_ASSET__532af1b0__"